import router from './router'
import { createApp } from './base'
import { HttpUtil } from 'kuaidong-lib'

HttpUtil.setWithCredentials()

createApp(router)
